export const getFormattedPrice = (price) => {
  return price ? `$${(price / 100).toFixed(0)}` : "TBA";
};

export const getRequestLimit = (limit) => {
    return limit !== null ? `Up to ${limit} Requests per Month` : "Unlimited Requests";
}
